import { IResult } from "../../Models/Result/IResult";
import { Result } from "../../Models/Result/Result";

export function formatUrl(url?: string, path?: string): string {
    if (url && path) {
        if (!url.endsWith("/")) {
            url = url + "/";
        }
        if (path.startsWith("/")) {
            path = path.substring(1);
        }
        return url + path;
    }
    else {
        throw new Error("url and path cannot be undefined");
    }
}

export function handleError<T>(error: any, callerName: string): IResult<T> {
    if (error.isAxiosError) {
        console.log(error);
        if (error.response && error.response.data && error.response.data.message) {
            return Result.Fail(-1, error.response.data.message);
        }

        //trackException(error, getProperties(callerName, error.name, error.message, error.lineNumber));
        return Result.Fail(-1, error.message);
    }
    else {
        console.error(error);
        //trackException(error, getProperties(callerName, error.name, error.message, error.lineNumber));
        return Result.Fail(-1, error.message);
    }
}
